module.exports = __webpack_public_path__ + "static/img/6_wurenji.c89fc79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/6_wurenji.png
// module id = xnJj
// module chunks = 0